export const FETCH_RELATED_SERVICES = {
  init: 'relatedServices/FETCH_RELATED_SERVICES/init',
  request: 'relatedServices/FETCH_RELATED_SERVICES/request',
  success: 'relatedServices/FETCH_RELATED_SERVICES/success',
  failure: 'relatedServices/FETCH_RELATED_SERVICES/failure',
  cancel: 'relatedServices/FETCH_RELATED_SERVICES/cancel',
} as const;

export const RELATED_SERVICES_STORE_NAME = 'relatedServices' as const;
